if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.surface = this.querySelector('[role="document"]');
        this.surface.addEventListener('pointerdown', this.startGesture.bind(this));
        this.surface.addEventListener('pointermove', this.moveGesture.bind(this));
        this.surface.addEventListener('pointerup', this.endGesture.bind(this));
        this.surface.addEventListener('pointercancel', () => { this.gesture = null; });
        this.surface.addEventListener('click', (event) => {
          if (!this.mobile.matches || event.target.tagName !== 'IMG') return;
          event.preventDefault();
          event.stopPropagation();
          if (this.suppressClick) { this.suppressClick = false; return; }
          this.toggleZoom(event.clientX, event.clientY);
        });
        // Dawn closes a media modal on mouse pointerup. Keep that desktop behavior,
        // but let mobile image gestures finish without closing the modal.
        this.surface.addEventListener('pointerup', event => {
          if (this.mobile.matches && event.target.tagName === 'IMG') event.stopPropagation();
        });
        this.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.stepMedia(event.key === 'ArrowRight' ? 1 : -1);
        });
      }

      hide() {
        this.resetZoom();
        this.gesture = null;
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.resetZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        if (this.mobile.matches) {
          this.surface.scrollTop = 0;
          this.surface.scrollLeft = 0;
        } else activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (!this.mobile.matches) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      resetZoom() {
        this.surface?.querySelectorAll('img').forEach(image => {
          image.style.transform = '';
          image.style.transformOrigin = '';
        });
        this.classList.remove('ttv-photo-zoomed');
        this.zoom = 1;
        this.panX = 0;
        this.panY = 0;
      }

      toggleZoom(x, y) {
        const image = this.surface.querySelector('img.active');
        if (!image) return;
        if (this.zoom > 1) { this.resetZoom(); return; }
        const rect = image.getBoundingClientRect();
        // Coordinates refer to the fitted image, not its natural 1100px width.
        image.style.transformOrigin = `${Math.max(0, Math.min(100, (x - rect.left) / rect.width * 100))}% ${Math.max(0, Math.min(100, (y - rect.top) / rect.height * 100))}%`;
        this.zoom = 2.5;
        this.classList.add('ttv-photo-zoomed');
        this.paintZoom(image);
      }

      paintZoom(image) {
        image.style.transform = `translate(${this.panX}px, ${this.panY}px) scale(${this.zoom})`;
      }

      startGesture(event) {
        if (!this.mobile.matches || event.target !== this.surface.querySelector('img.active')) return;
        if (!event.isPrimary) { this.gesture = null; return; }
        this.suppressClick = false;
        this.gesture = { x: event.clientX, y: event.clientY, panX: this.panX, panY: this.panY };
        event.target.setPointerCapture(event.pointerId);
      }

      moveGesture(event) {
        if (!this.gesture || this.zoom <= 1) return;
        const image = this.surface.querySelector('img.active');
        if (!image) return;
        const limitX = image.clientWidth * (this.zoom - 1);
        const limitY = image.clientHeight * (this.zoom - 1);
        this.panX = Math.max(-limitX, Math.min(limitX, this.gesture.panX + event.clientX - this.gesture.x));
        this.panY = Math.max(-limitY, Math.min(limitY, this.gesture.panY + event.clientY - this.gesture.y));
        this.paintZoom(image);
      }

      endGesture(event) {
        if (!this.gesture) return;
        const dx = event.clientX - this.gesture.x;
        const dy = event.clientY - this.gesture.y;
        this.gesture = null;
        if (Math.hypot(dx, dy) > 12) this.suppressClick = true;
        if (this.zoom === 1 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          this.stepMedia(dx < 0 ? 1 : -1);
        }
      }

      stepMedia(direction) {
        const media = [...this.surface.children].filter(element => element.hasAttribute('data-media-id'));
        if (media.length < 2) return;
        const index = media.findIndex(element => element.classList.contains('active'));
        const next = media[(index + direction + media.length) % media.length];
        this.resetZoom();
        window.pauseAllMedia();
        media.forEach(element => element.classList.toggle('active', element === next));
        this.surface.scrollTop = 0;
        this.surface.scrollLeft = 0;
      }
    }
  );
}

